<ion-content>
  <div class="ratings-wrapper">
    <div class="ratings">
      <div class="rating-wrapper">
        <div class="rating">
          <div class="rating-score">{{ rating.service | number: "1.1-1" }}</div>
          <div class="rating-type">{{ "RATINGS.SERVICE" | translate }}</div>
        </div>
      </div>
      <div class="rating-wrapper">
        <div class="rating">
          <div class="rating-score">{{ rating.products | number: "1.1-1" }}</div>
          <div class="rating-type">{{ "RATINGS.PRODUCTS" | translate }}</div>
        </div>
      </div>
      <div class="rating-wrapper">
        <div class="rating">
          <div class="rating-score">{{ rating.timeliness | number: "1.1-1" }}</div>
          <div class="rating-type">{{ "RATINGS.TIMELINESS" | translate }}</div>
        </div>
      </div>
      <div class="rating-wrapper">
        <div class="rating">
          <div class="rating-score">{{ rating.presentation | number: "1.1-1" }}</div>
          <div class="rating-type">{{ "RATINGS.PRESENTATION" | translate }}</div>
        </div>
      </div>
    </div>
  </div>

  <div class="reviews" *ngIf="visibleReviews.length">
    <div class="reviews-title">{{ "VENDOR_REVIEWS_MODAL_PAGE.TITLE" | translate: { total: reviews.length } }}</div>
    <div class="review" *ngFor="let review of visibleReviews">
      <div class="review-info">
        <div class="reviewer">{{ review.displayName }}</div>
        <app-rating [rating]="review.rating.overall"></app-rating>
      </div>
      <div class="review-feedback">{{ review.feedback }}</div>
      <div class="review-date">{{ review.createdDateFormatted }}</div>
    </div>
  </div>

  <ion-infinite-scroll [threshold]="'100%'" *ngIf="visibleReviews.length && !areAllReviewsLoaded" (ionInfinite)="onLoadMoreReviews($event)">
    <ion-infinite-scroll-content></ion-infinite-scroll-content>
  </ion-infinite-scroll>
</ion-content>
